import { nanoid } from "nanoid";
import { creativeIDSplit } from "../constants/ads";

export function createInstance(_class, ...args) {
  return new _class(...args);
}

export function generateCreativeID(templateID, imageID) {
  return `${templateID}${creativeIDSplit}${imageID}`;
}

export function createImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      resolve(image);
    };
    image.onerror = (error) => {
      reject(error);
    };
    image.src = src;
  });
}

export function createCrossOriginImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = () => {
      resolve(image);
    };
    image.onerror = (error) => {
      reject(error);
    };
    image.src = src + "?r=" + nanoid();
  });
}

export function initializeCanvasFont({ size, fontWeight, fontFamily = "Eudoxus Sans" }) {
  const weights = { 100: "thin", 200: "lighter", 300: "light", 400: "normal", 500: "medium", 600: "semibold", 700: "bold", 800: "bolder", 900: "black" };
  const weight = typeof fontWeight === "number" ? weights[fontWeight] : fontWeight;
  return [`${size}px`, weight, fontFamily].filter(Boolean).join(" ").trim();
}
export async function addFontFace(name, url) {
  if (!name || !url)
    return {
      error: "Unable to load font. Default font will be used to preview",
      name: "Eudoxus Sans",
    };

  try {
    document.fonts.check(name);
    return { error: null, name };
  } catch (e) {
    try {
      const fontFace = new FontFace(name, `url(${url})`);
      document.fonts.add(fontFace);
      await fontFace.load();
      return { error: null, name };
    } catch (e) {
      return { error: "Unable to load font. Default font will be used to preview", name: "Eudoxus Sans" };
    }
  }
}

export function splitStringByWrapLength(text, wrapLength) {
  if (!wrapLength || wrapLength > text.length - 1) return [text];
  const lastIndexOfSpaceBeforeWrapLength = text.lastIndexOf(" ", wrapLength);
  return [text.slice(0, lastIndexOfSpaceBeforeWrapLength).trim(), ...splitStringByWrapLength(text.slice(lastIndexOfSpaceBeforeWrapLength).trim(), wrapLength)];
}

export function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}
